export const INVESTMENT_STRUCTURE_OPTIONS = [
  { value: 'None', label: 'None' },
  { value: 'Co-Investment', label: 'Co-Investment' },
  { value: 'Separately Managed Account', label: 'Separately Managed Account' }
];

export const INVESTMENT_STRUCTURE_OPTIONS_RA = [
  { id: 'None', name: 'None' },
  { id: 'Co-Investment', name: 'Co-Investment' },
  { id: 'Separately Managed Account', name: 'Separately Managed Account' }
];

export function mapInvestmentStructureToBooleans(selected) {
  switch (selected) {
    case 'Co-Investment':
      return { coInvestment: true, sma: false };
    case 'Separately Managed Account':
      return { coInvestment: false, sma: true };
    default:
      return { coInvestment: false, sma: false };
  }
}

export function deriveInvestmentStructureFromBooleans(coInvestment, sma) {
  if (Boolean(coInvestment) && !Boolean(sma)) return 'Co-Investment';
  if (!Boolean(coInvestment) && Boolean(sma))
    return 'Separately Managed Account';
  return 'None';
}
